import { render, staticRenderFns } from "./DoubleRandom.vue?vue&type=template&id=7bb21e1f&scoped=true"
import script from "./DoubleRandom.vue?vue&type=script&lang=js"
export * from "./DoubleRandom.vue?vue&type=script&lang=js"
import style0 from "./DoubleRandom.vue?vue&type=style&index=0&id=7bb21e1f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb21e1f",
  null
  
)

export default component.exports